<template>
  <div class="life_costs-header clearfix" id="life_costs-header">
    <div class="partner-account clearfix J_partner_headcont">
      <a-popover placement="bottomRight">
        <template slot="content">
          <a class="J_updateModel" style="padding: 5px;display:block;color: #999;" @click.stop="updateModel(true)">
            <a-icon type="unlock" style="padding-right:15px;color: #00f;" />
            <span class="pull-left" >修改密码</span>
          </a>
          <a class="head-backout clearfix" style="padding: 5px;display:block;color: #999;" @click.stop="backOut">
            <a-icon type="logout" style="padding-right:15px;color:#fb5130;" />
            <span class="pull-left">退出</span>
          </a>
        </template>
        <template slot="title">
          <span>{{userInfo.userName}}</span>
        </template>
        <a-icon class="trigger" type="user" ref="userName" :userName="userInfo.userName" />
      </a-popover>
    </div>
    <a-modal v-model="pageData.visible" title="修改密码" :footer="null">
      <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }" @submit="savePwd">
        <a-form-item label="手机号">
          <a-input v-decorator="[
            'userName', { 
              initialValue: userInfo.userName,
              rules: [{ required: true, message: '请输入手机号!' }] 
            }
          ]" disabled />
        </a-form-item>
        <a-form-item label="新密码">
          <a-input v-decorator="[
            'newPassword1', { 
              initialValue: userInfo.newPassword1,
              rules: [{ required: true, message: '请输入新密码!' }] 
            }
          ]" />
        </a-form-item>
        <a-form-item label="确定新密码">
          <a-input v-decorator="[
            'newPassword2', { 
              initialValue: userInfo.newPassword2,
              rules: [{ required: true, message: '请输入确定新密码!' }] 
            }
          ]" />
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 12, offset: 5 }">
          <a-button class="space-margin-right" type="primary" html-type="submit" :loading="pageData.loading">确认</a-button>
          <a-button @click.stop="resetEvt">取消</a-button>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import ajax from '../../lib/axios/ajax';
import { loginGetUserInfo, loginSetPassword, loginLogout } from '../../lib/axios/apilist';

export default {
  data(){
    return {
      ajaxParam: {
        loginGetUserInfo: loginGetUserInfo,
        loginSetPassword: loginSetPassword,
        loginLogout: loginLogout,
      },
      userInfo: {
        userName: undefined,
        newPassword1: undefined,
        newPassword2: undefined
      },
      pageData:{
        visible: false,
        loading: false,
      },
      form: this.$form.createForm(this)
    }
  },
  mounted() {
    //进入页面
    //cabinVue 里面所有的this 都指向当前这个vue 实例
    //vue 更多使用方法请查看vue官方文档
    this.$nextTick(function () {
      //nextTick 用于当data数据改变,触发vue 渲染,且渲染完毕使用

    });
    this.initFunc()
  },
  //如果 不需要保存页面状态必须添加下面这个方法
  beforeDestroy: function () {
    this.form = this.$form.createForm(this);
  },
  destroyed: function () {
    //离开页面方法
  },
  //监听属性变化，，变量必须是data里声明的
  watch: {},
  //监听属性变化，配置变量的同时也起到data声明的作用
  computed: {},
  methods:{
    initFunc(){
      //搜索地址
      let url = this.ajaxParam.loginGetUserInfo;
      let successFunc = (res) => {
        if (res.code === "0000") {
          this.userInfo.userName = res.data
        } else {
          this.$error({
            title: '提示',
            content: res.result,
          });
        }
      };
      let errorFunc = () => {
      };
      let requestParam = {
      }
      //fetch ajax提交数据
      ajax.fetch(url, requestParam, successFunc, errorFunc)
    },
    backOut(){
      this.$confirm({
        title: '提示',
        content: '确认退出吗？',
        onOk:() => {
          //搜索地址
          let url = this.ajaxParam.loginLogout;
          let successFunc = (res) => {
            if (res.code === "0000") {
              this.$router.push({
                path: '/login'
              })
            } else {
              this.$error({
                title: '提示',
                content: res.result,
              });
            }
          };
          let errorFunc = () => {
          };
          var returnUrl = window.location.href;
          let requestParam = {
            'userId': this.userInfo.userName,
            'returnUrl': returnUrl
          }
          //fetch ajax提交数据
          ajax.fetch(url, requestParam, successFunc, errorFunc)
        },
      });
    },
    updateModel(visible){
      this.pageData.visible = visible
    },
    savePwd(e){
      e.preventDefault();
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          this.submit(values)
        }
      });
      
    },
    submit(params){
      this.pageData.loading = true
      let url = this.ajaxParam.loginSetPassword;
      let successFunc = (res) => {
        this.pageData.loading = false
        if (res.code === "0000") {
          this.$message.success(res.result);
        } else {
          this.$error({
            title: '提示',
            content: res.result,
          });
        }
      };
      let errorFunc = () => {
        this.pageData.loading = false
      };
      let requestParam = {
        ...params,
      }
      //fetch ajax提交数据
      ajax.fetch(url, requestParam, successFunc, errorFunc)
    },
    resetEvt(){
      this.form.resetFields()
      this.userInfo = {
        ...this.userInfo,
        newPassword1: undefined,
        newPassword2: undefined
      }
      this.updateModel(false)
    }
  }
}
</script>

<style scoped>
.life_costs-header {
  float: right;
	height: 100%;
  position: relative;
  padding: 0 15px;
}
.life_costs-header .partner-account .partner-account-img {
	background: url(../../../public/images/avatar.png) no-repeat center;
	width: 35px;
	height: 35px;
	border-radius: 50%;
	display: block;
	margin: 10px 0 0 20px;
}
.life_costs-header .username {
	color: #808080;
	font-size: 14px;
}
.life_costs-header .dropdown-menu {
	border: 1px solid #f5f5f5!important;
	box-shadow: 0 2px 15px 1px rgba(0, 0, 0, 0.12)!important;
}
.life_costs-header .J_back_out .head-backout {
	cursor: pointer;
}
.life_costs-header .J_back_out .head-backout:hover {
	background: #fff;
}
.life_costs-header .head-backout i {
	width: 20px;
	height: 20px;
	margin-left: 25px;
	display: block;
	background: url(../../../public/images/icon-logout.png) no-repeat center;
}
.life_costs-header .head-backout span {
	margin-left: 10px;
	display: block;
	color: #999999;
}
.size-task-dropcont .size-small-icon {
  width: 16px;
  display: block;
  opacity: .5;
  height: 25px;
  background: url(../../../public/images/size-small.png) center no-repeat;
}
.partner-size-list.active i {
  opacity: 1!important;
}
.size-task-dropcont .size-normal-icon {
  width: 16px;
  display: block;
  opacity: .5;
  height: 25px;
  background: url(../../../public/images/size-normal.png) center no-repeat;
}
.size-task-dropcont .size-large-icon {
  width: 16px;
  display: block;
  opacity: .5;
  height: 25px;
  background: url(../../../public/images/size-large.png) center no-repeat;
}
.partner-size-list.active a {
  background-color: #fff!important;
}
.partner-size-list.active .size-text {
  color: #333!important;
}
.size-task-dropcont .size-text {
  margin-left: 7px;
  display: block;
  color: #999;
  line-height: 25px;
}
.life_costs-header .header-logo-container {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-pack: center;
  justify-content: center;
  -ms-flex-align: center;
  align-items: center;
  height: 50px;
  width: 16px;
  margin-right: 20px;
  position: relative;
}
.J_partner_headcont .msg_center_icon {
  color: grey;
  cursor: pointer;
  position: relative;
  text-align: center;
}
</style>